import React, { useState, useCallback } from 'react';
import classNames from 'classnames';
import {
  Wrapper,
  Grid,
  Content,
  BackgroundImageWrapper,
  BackgroundImages,
  BlueBackgroundImage,
  WhiteBackgroundImage,
  GreenBackgroundImage,
  LogoImage,
  TextWrapper,
  StyledTitle,
  StyledText,
  CustomerName,
  CustomerPosition,
  Buttons,
  PrevButton,
  NextButton,
  ButtonsList,
  ButtonsListItem,
  TabButton
} from './styles';

interface Props {
  data: {
    logo: any;
    text: string;
    customerName: string;
    customerPosition: string;
  }[];
}

export default function Confie({ data }: Props) {
  const [activeTab, setActiveTab] = useState(0);
  const [transitioning, setTransitioning] = useState(false);

  const changeTab = useCallback(
    tab => {
      if (tab !== activeTab && !transitioning) {
        setTransitioning(true);
        setTimeout(() => {
          setActiveTab(tab);
          setTransitioning(false);
        }, 500);
      }
    },
    [activeTab, transitioning]
  );

  const prevTab = useCallback(() => {
    changeTab(activeTab === 0 ? data.length - 1 : activeTab - 1);
  }, [activeTab, changeTab]);

  const nextTab = useCallback(() => {
    changeTab(activeTab === data.length - 1 ? 0 : activeTab + 1);
  }, [activeTab, changeTab]);

  return (
    <Wrapper>
      <Grid className="grid">
        <Content>
          <BackgroundImageWrapper className={classNames({ transitioning })}>
            <BackgroundImages>
              <BlueBackgroundImage
                src={require('assets/confie-blue-background.svg')}
                alt=""
              />
              <WhiteBackgroundImage
                src={require('assets/confie-white-background.svg')}
                alt=""
              />
              <GreenBackgroundImage
                src={require('assets/confie-green-background.svg')}
                alt=""
              />
            </BackgroundImages>
            <LogoImage src={data[activeTab].logo} alt="" />
          </BackgroundImageWrapper>
          <TextWrapper className={classNames({ transitioning })}>
            <StyledTitle>Confie em quem usa</StyledTitle>
            <StyledText>{data[activeTab].text}</StyledText>
            <CustomerName>{data[activeTab].customerName}</CustomerName>
            <CustomerPosition>
              {data[activeTab].customerPosition}
            </CustomerPosition>
            {data.length > 1 && (
              <Buttons>
                <PrevButton onClick={prevTab}>Anterior</PrevButton>
                <ButtonsList>
                  {data.map((_tab, index) => (
                    <ButtonsListItem key={index}>
                      <TabButton
                        active={activeTab === index}
                        onClick={() => changeTab(index)}
                      >
                        {index + 1}
                      </TabButton>
                    </ButtonsListItem>
                  ))}
                </ButtonsList>
                <NextButton onClick={nextTab}>Próximo</NextButton>
              </Buttons>
            )}
          </TextWrapper>
        </Content>
      </Grid>
    </Wrapper>
  );
}
